import type { ListingDesignItem } from '../../domain/models/ProductListing';

export function getProductCardDescriptionLines(product: ListingDesignItem): string[] {
  const metal = product.displayMetal?.trim() ?? '';
  const purity = /silver|platinum/i.test(metal) ? '' : product.goldPurity?.trim();
  const weight = product.metalWeight;
  const metalLine = [purity, metal, weight != null && Number.isFinite(weight) ? `(${weight.toFixed(2)} gram)` : ''].filter(Boolean).join(' ');
  const lines = metalLine ? [metalLine] : [];
  if (product.solitaireTotalCarat != null && Number.isFinite(product.solitaireTotalCarat)) lines.push(`Solitaire ${product.solitaireTotalCarat.toFixed(3)}Ct`);
  if (product.diamondCarat != null && Number.isFinite(product.diamondCarat)) lines.push(`Diamond ${product.diamondCarat.toFixed(3)}Ct`);
  return lines;
}
